import React, { useState } from "react"
import moment from "moment"

import { Box, Button, Grid, Typography, Tooltip, Collapse, useMediaQuery, useTheme } from "@mui/material"
import { FaChevronDown, FaChevronLeft, FaChevronUp } from "react-icons/fa6"
import * as Style from "./style"
import { useNavigate, useParams } from "react-router-dom"
import dummy from "../../images/dummy-image.jpg"
import chat from "../../images/chat.svg"
import { BsInfoCircleFill } from "react-icons/bs"

interface Props {
  dateString: string
}

export function FormatDate({ dateString }: Props) {
  const date = moment.utc(dateString).local()
  return <>{date.format("dddd")}</>
}

export function FormatTime({ dateString }: Props) {
  const date = moment.utc(dateString).local()
  return <div>{date.format("D-MMMM")}</div>
}

export function FormatChangeTime({ dateString }: Props) {
  const date = moment.utc(dateString).local()
  return <div> {date.format("h:mm A")}</div>
}

export function FormatDateMonthDay({ dateString }: Props) {
  const date = moment.utc(dateString).local()
  return <div>{date.format("DD MMM, dddd")}</div>
}

import CenteredSpinner from "../common/CenteredSpinner"

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab"
import { useApprovedJobsQuery } from "../../features/Auth/authApi"
import { CiMail } from "react-icons/ci"
import { LuPhone } from "react-icons/lu"
import { useCreateTicketMutation } from "../../features/ChatAuth/chatApi"
import PreviewImage from "../common/previewImage"
import ExtraDetailsDisplay from "../ExtraDetailsSeeker/ExtraDetailsDisplay"
const BookingServiceDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [showFullTimeline, setShowFullTimeline] = useState(false)
  const [showExtraDetails, setShowExtraDetails] = useState(false)
  const [chatView, { data: CharacterData }] = useCreateTicketMutation()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const urlSearchParams = new URLSearchParams(window.location.search)
  const view = urlSearchParams.get("view")
  const handleToggleTimeline = () => {
    setShowFullTimeline(!showFullTimeline)
  }
  const { data: approvedjobs, isLoading } = useApprovedJobsQuery({ postId: id })

  const handleChatView = async () => {
    const payload = {
      postId: id,
    }

    try {
      const response: any = await chatView(payload)
      if (response?.data?.status === 200) {
        const chatId = response.data?.data?._id
        const adminId = response.data?.data?.adminstration

        if (chatId && adminId) {
          navigate(`/dashboard/help-center?chatId=${chatId}&adminId=${adminId}`)
        } else {
          console.error("Invalid chatId or adminId in response:", response)
        }
      } else {
        console.error("API call was not successful:", response)
      }
    } catch (error) {
      console.error("Error making API call:", error)
    } finally {
    }
  }

  const handlenavigate = () => {
    if (view == "booking-detail") {
      navigate("/dashboard/job-history/All")
    } else {
      navigate(-1)
    }
  }

  // image preview on click

  const handleImageClick = (image: string) => {
    setSelectedImage(image)
  }

  const handleClosePreview = () => {
    setSelectedImage(null)
  }

  // *******
  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          <Box className="">
            {Array.isArray(approvedjobs?.data) && approvedjobs?.data?.map((item: any) => (
              <Style.Overview>
                <Box className="feature-card py-4 px-2">
                  <Box className="d-flex justify-content-between align-items-center pb-3">
                    <Box className="d-flex align-items-center gap-4">
                      <Button
                        className="back-btn mb-0"
                        onClick={handlenavigate}
                      >
                        <FaChevronLeft />
                      </Button>
                      <Typography variant="h2" className=" mb-0">
                        Service Details
                      </Typography>
                    </Box>

                    <Box>
                      <Typography className="status-text mb-0">
                        Status - {" "}
                        <span
                          className="completed fw-bold"
                          style={{
                            color:
                              item.status == "Completed"
                                ? "green"
                                : item.status == "Declined"
                                  ? "red"
                                  : item.status == "Expired"
                                    ? "red"
                                    : item.status == "Accepted"
                                      ? "green"
                                      : item.status == "Pending"
                                        ? "yellow"
                                        : "",
                            fontWeight: "bold",
                          }}
                        >
                          {item?.status}
                        </span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="p-4 service-detail-box-lg">
                    <Grid container spacing={2}>
                      {/* LEFT SIDE: 40% */}
                      <Grid item xs={12} md={5} lg={4} xl={3}>
                        <Box className="text-center d-flex flex-column align-items-center h-100 p-3 border rounded">
                          <Box className="mb-3">
                            <img
                              src={item?.seekerData?.profilePic || dummy}
                              alt="profile"
                              className="profile-img-2"
                            />
                          </Box>
                          <Typography
                            variant="body1"
                            align="center"
                            className="mb-3 fw-bold"
                          >
                            {item?.seekerData?.name}
                          </Typography>

                          <Typography
                            variant="body1"
                            className="mb-2 fw-bold d-inline-flex gap-1 align-items-center"
                            sx={{
                              maxWidth: 180,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <CiMail color="#F475A4" />
                            <span>
                              {item?.seekerData?.email?.length > 16
                                ? item.seekerData.email.slice(0, 16) + "..."
                                : item?.seekerData?.email}
                            </span>
                            <Tooltip
                              title={item?.seekerData?.email || ""}
                              arrow
                            >
                              <Button
                                style={{ minWidth: "10px" }}
                                className="m-0 p-0"
                              >
                                <BsInfoCircleFill color="#F475A4" />
                              </Button>
                            </Tooltip>
                          </Typography>

                          <Typography
                            variant="body2"
                            align="center"
                            className="d-flex fw-bold justify-content-center gap-1"
                          >
                            <LuPhone color="#F475A4" />{" "}
                            {item?.seekerData?.contactNo}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* RIGHT SIDE: 60% */}
                      <Grid item xs={12} md={7} lg={8} xl={9}>
                        <Box
                          sx={{
                            maxHeight: "400px",
                            overflowY: "auto",
                            paddingRight: "8px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          {[
                            {
                              label: "Service Required",
                              value: item?.service?.name,
                            },
                            {
                              label: "Number Of Providers Required",
                              value: item?.personRequired,
                            },
                            // {
                            //   label: "Age Of Provider",
                            //   value: item?.ageRange?.join("-"),
                            // },
                            {
                              label: "Service Date",
                              value: (() => {
                                if (!item?.from) return "-"
                                const date = moment.utc(item.from).local()
                                return (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <span>{date.format("D MMMM, dddd YYYY")}</span>
                                  </Box>
                                )
                              })(),
                            },
                            {
                              label: "Service Time",
                              value: (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <FormatChangeTime dateString={item?.from} />
                                  <span>-</span>
                                  <FormatChangeTime dateString={item?.till} />
                                </Box>
                              ),
                            },
                            {
                              label: "Language",
                              value: item?.language?.join(", "),
                            },
                            {
                              label: "Location",
                              value: item?.location,
                            },
                            {
                              label: "Additional Instructions",
                              value: item?.description,
                              condition: !!item?.description,
                            },
                          ].map(
                            (field, idx) =>
                              (field.condition === undefined ||
                                field.condition) && (
                                <Box
                                  key={idx}
                                  className="p-3"
                                  sx={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    background: "#fafafa",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight={600}
                                    mb={0.5}
                                  >
                                    {field.label}
                                  </Typography>
                                  <Typography variant="body2">
                                    {field.value}
                                  </Typography>
                                </Box>
                              ),
                          )}

                          {/* Uploaded Photos */}
                          {item?.attachments?.length > 0 && (
                            <Box
                              className="p-3"
                              sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                background: "#fafafa",
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                fontWeight={600}
                                mb={1}
                              >
                                Uploaded Photos
                              </Typography>
                              <Box className="d-flex flex-wrap gap-2">
                                {item.attachments.map(
                                  (img: string, idx: number) => (
                                    <img
                                      key={idx}
                                      src={img || dummy}
                                      alt={`upload-${idx}`}
                                      style={{
                                        height: "48px",
                                        width: "48px",
                                        objectFit: "cover",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleImageClick(img)}
                                    />
                                  ),
                                )}
                              </Box>
                            </Box>
                          )}

                          {/* image preview */}
                          <PreviewImage
                            selectedImage={selectedImage}
                            handleClosePreview={handleClosePreview}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>

                {/* Additional Info Section - Below the service details container */}
                <Box className="py-2 px-0 bg-white my-2" sx={{ maxHeight: "500px", borderRadius: "18px" }}>
                  {item?.extraDetails && (
                    <Box className="px-4 mt-1">
                      <Button
                        variant="outlined"
                        onClick={() => setShowExtraDetails(!showExtraDetails)}
                        className="text-capitalize d-flex align-items-center gap-2"
                        style={{
                          borderColor: "#F475A4",
                          color: "#F475A4",
                          fontWeight: "600",
                          padding: "8px 16px",
                        }}
                      >
                        {showExtraDetails ? (
                          <>
                            <FaChevronUp size={14} />
                            Hide Additional Information
                          </>
                        ) : (
                          <>
                            <FaChevronDown size={14} />
                            Show Additional Information
                          </>
                        )}
                      </Button>

                      <Collapse in={showExtraDetails}>
                        <Box className="mt-3 p-2 border rounded">
                          <ExtraDetailsDisplay
                            extraDetails={item?.extraDetails}
                            serviceName={item?.service?.name}
                          />
                        </Box>
                      </Collapse>
                    </Box>
                  )}
                </Box>
              </Style.Overview>
            ))}
          </Box>

          <Style.Overview>
            <Box
              className="d-flex my-5"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography align="left" variant="h2" mb={2}>
                Timeline
              </Typography>
              <Box display="flex">
                <Button className="timeline-btn" onClick={handleChatView}>
                  Chat{" "}
                  <img
                    src={chat}
                    alt="chat"
                    style={{ color: "#F475A4", marginLeft: "10px" }}
                  />
                </Button>
              </Box>
            </Box>

            <Box className="timeline-graph"
              sx={{
                overflowX: "auto",
                px: { xs: 1, sm: 0 },
              }}
            >
              {approvedjobs?.timeLine
                ?.slice(
                  0,
                  showFullTimeline ? approvedjobs?.timeLine?.length : 3,
                )
                .map((timeline: any, index: number) => (
                  <Timeline
                    key={timeline._id}
                    position={index % 2 === 0 ? "alternate" : "left"}
                    sx={{
                      ...(isMobile && {
                        // ✅ apply ONLY on mobile
                        flexDirection: "column",
                        "& .MuiTimelineItem-root": {
                          flexDirection: "column !important",
                        },
                        "& .MuiTimelineOppositeContent-root": {
                          position: "relative",
                          textAlign: "left",
                          margin: "0 0 8px 0",
                          flex: "none",
                          width: "100%",
                        },
                        "& .MuiTimelineSeparator-root": {
                          minHeight: "40px",
                        },
                        "& .MuiTimelineContent-root": {
                          marginTop: "8px",
                        },
                      }),
                    }}
                  >
                    <TimelineItem>
                      <TimelineOppositeContent
                        sx={{ m: "10px 0 0" }}
                        align="right"
                        className="timeline-desc"
                        color="text.secondary"
                      >
                        <span className="datetime">
                          <span className="d-flex flex-column">
                            <span className="weekday">
                              <FormatDate dateString={timeline.createdAt} />
                            </span>
                            <span>
                              <FormatChangeTime
                                dateString={timeline.createdAt}
                              />
                            </span>
                            <span>
                              <FormatTime dateString={timeline.createdAt} />
                            </span>
                          </span>
                        </span>
                        <br />
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot>
                          <Typography className="timeline-step">
                            0{approvedjobs?.timeLine?.length - index}
                          </Typography>
                        </TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent sx={{ py: "12px", px: 0.5 }}>
                        <Box className="timeline-content ">
                          <Typography className="timeline-heading">
                            Status -{timeline?.postStatus}{" "}
                          </Typography>
                          <Typography className="timeline-desc"></Typography>
                          <Typography className="timeline-desc">
                            {timeline?.message}{" "}
                          </Typography>
                        </Box>
                      </TimelineContent>
                    </TimelineItem>
                  </Timeline>
                ))}
              {approvedjobs?.timeLine?.length > 3 && (
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={handleToggleTimeline}
                    className="view-profile py-2 text-capitalize"
                  >
                    {showFullTimeline ? "Show Less" : "Show More"}
                  </Button>
                </div>
              )}
            </Box>
          </Style.Overview>
        </>
      )}
    </>
  )
}
export default BookingServiceDetails
